import styled from "styled-components";

const CommentButton = styled.button`
  width: 50px;
  background-color: transparent;
  border: none;
  color: #0095f6;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
`;

export default CommentButton;
